import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NextButtonStateService {noTimeslotsWorkButtonState
  private activateNextSubject = new Subject<boolean>();
  private activateNoTimeslotsWorkButtonSubject = new Subject<boolean>();
  activateNext$: Observable<any> = this.activateNextSubject.asObservable();
  activateNoTimeslotsWorkButton$: Observable<any> = this.activateNoTimeslotsWorkButtonSubject.asObservable();

  emitActivateNext(isActive: boolean): void {
    this.activateNextSubject.next(isActive);
  }

  emitActivateNoTimeslotsWorkButton(isActive: boolean): void {
    this.activateNoTimeslotsWorkButtonSubject.next(isActive);
  }
}
